'use client';

import dynamic from 'next/dynamic';
import { useState } from 'react';

const DevToolsPortal = dynamic(() => import('./DevToolsPortal'), { ssr: true });

type Props = {
  extractedHeaders: Record<string, string | null>;
};

export default function RequestDebugInfoClient({ extractedHeaders }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <DevToolsPortal>
      {!isVisible ? (
        <button
          type="button"
          onClick={() => {
            setIsVisible(true);
          }}
          className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-800 text-yellow-400 shadow-lg transition-all hover:scale-110 hover:bg-gray-700"
          title="Show Debug Info"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
      ) : (
        <div className="max-w-md rounded border bg-gray-900 p-4 text-xs text-white shadow-xl">
          <div className="mb-2 flex items-center justify-between">
            <h3 className="font-bold text-yellow-400">Debug Info</h3>
            <button
              type="button"
              onClick={() => {
                setIsVisible(false);
              }}
              className="flex h-5 w-5 items-center justify-center text-lg font-bold text-gray-400 hover:text-white"
            >
              ×
            </button>
          </div>
          <div className="space-y-1">
            {Object.entries(extractedHeaders).map(([key, value]) => (
              <div key={key}>
                <span className="text-gray-400">{key}:</span> {value ?? 'null'}
              </div>
            ))}
          </div>
        </div>
      )}
    </DevToolsPortal>
  );
}
